export const onOwnwellDotCom = () => {
	return (
		typeof window !== "undefined" &&
		window.location.origin === "https://www.ownwell.com"
	);
};
